import { FormsOverviewTable } from "../../../components/FormsOverviewTable/FormsOverviewTable";

export const PublicFormResults = () => {
    return (
        <div>
            <FormsOverviewTable overview={false} />
        </div>
    );
};
